import {MarkupNodeType} from '#src/constants.js';
import {createHtmlTag, toBase64} from '#src/helper.js';
import {SkipType} from '#src/processing-context.js';

function convertTooltipShitty({matchStart, options}) {
  const {tooltip, word} = matchStart.groups;

  options.skipType = SkipType.NoSkip;
  options.op = createHtmlTag(
    MarkupNodeType.Tooltip,
    {'data-tooltip': toBase64(tooltip)},
    {isMarkdown: true, isNonClosing: true}
  );
  options.cl = '</div>';

  return word;
}

export default [{
  cl: null,
  convert: convertTooltipShitty,
  op: /(?<word>[^?\s]+)\?{3}"(?<tooltip>[^"]+)"/giu,
  priority: 2100
}];
